// ABOUTME: UI component for SharePoint search input controls
// ABOUTME: Provides search input field with proper styling and event handling
/* eslint-disable react/prop-types */

import { SearchIcon, TextField } from '@ds/coolshop';
import React from 'react';
import { useIntl } from 'react-intl';

type ISearchControlsProps = {
    readonly searchTerm: string;
    readonly onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    readonly placeholder?: string;
};

export const SearchControls: React.FC<ISearchControlsProps> = React.memo(
    ({ searchTerm, onSearchChange, placeholder }) => {
        const intl = useIntl();
        const searchPlaceholder =
            placeholder || intl.formatMessage({ id: 'sharepoint.search', defaultMessage: 'Cerca' });

        return (
            <TextField
                fullWidth
                size="small"
                placeholder={searchPlaceholder}
                value={searchTerm}
                onChange={onSearchChange}
                StartIcon={SearchIcon}
            />
        );
    },
);

SearchControls.displayName = 'SearchControls';
